import * as React from 'react';
import { AlertMessage, AlertType, ButtonType, CustomButton, CustomSubmitButton, Modal, ModalBody, ModalFooter, ModalSize } from 'soprasteria-ui-library';
import { OrthodonticReferralAdministrationApi } from '../../../../api/OrthodonticReferralAdministrationApi';
import { useAuth } from '../../../../App';

interface IOrthodonticReferralPatientViewModal {
    orthodonticReferralId: number;
    selectedOrthodonticReferralPatientViewingId: number;
    changeSuccessMessage: (message: string) => void;
    getOrthodonticReferral: (id: number, refresh: boolean) => void;
}

export const OrthodonticReferralPatientViewModal: React.FunctionComponent<IOrthodonticReferralPatientViewModal> = ({ orthodonticReferralId, selectedOrthodonticReferralPatientViewingId, getOrthodonticReferral, changeSuccessMessage }) => {

    const auth = useAuth();
    const api = new OrthodonticReferralAdministrationApi(auth);
    const [isConfirmingPatientViewing, setIsConfirmingPatientViewing] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>();

    React.useEffect(() => {

    }, [])

    const confirmOrthodonticReferralPatientViewing = () => {
        setIsConfirmingPatientViewing(true);
        api.confirmPatientViewing(selectedOrthodonticReferralPatientViewingId, 
            () => {
                getOrthodonticReferral(orthodonticReferralId, true);
                document.getElementById("close-orthodontic-referral-patient-viewing-modal")?.click();
                changeSuccessMessage("Patienten har markerats som kallad till visning");
            }, 
            (error) => {
                setErrorMessage(error);
            },
            () => {
                setIsConfirmingPatientViewing(false);
            });
    }

    return (
        <Modal id="orthodontic-referral-patient-viewing-modal" header="Kalla patient till visning" modalSize={ModalSize.large}>
            <ModalBody>
                <AlertMessage alertType={AlertType.danger} duration={3000}>{errorMessage}</AlertMessage>
                 Markera att patienten har kallats till visning?
            </ModalBody>
            <ModalFooter>
                <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-orthodontic-referral-patient-viewing-modal" />
                <CustomSubmitButton onButtonSubmit={confirmOrthodonticReferralPatientViewing} isLoading={isConfirmingPatientViewing}>Patienten har kallats till visning</CustomSubmitButton>
                <input type="hidden" data-toggle="modal" id="open-orthodontic-referral-patient-viewing-modal" data-target="#orthodontic-referral-patient-viewing-modal" />
            </ModalFooter>
        </Modal>
    )
}